import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import MySubscriptionsSkeleton from './mysubscriptionsSkeleton';

import {
  getCustomerId,
  getCustomerSubscriptions,
  getVirtualSpaces
} from '../../../store/actions';

import Alert from '../../../utils/components/Alerts';
import { getCustomer } from '../../../utils/helpers';

import { DateTime } from 'luxon';

const MySubscriptions = () => {

  const customerId = getCustomer();
  const dispatch = useDispatch();
  const subscriptionsInfo = useSelector((state) => state.mySubscriptions);
  const navigate = useNavigate();

  const [subscriptions, setSubscriptions] = useState([]);

  useEffect(() => {
    if (customerId === "") {
      navigate('/')
    }
  }, [])

  useEffect(() => {
    if (!subscriptionsInfo.userObtained) {
      dispatch(getCustomerId());
    }
  }, [subscriptionsInfo.userObtained])

  useEffect(() => {
    if (!subscriptionsInfo.instancesObtained && subscriptionsInfo.userEmail !== "") {
      dispatch(getVirtualSpaces(subscriptionsInfo.userEmail));
    }
  }, [subscriptionsInfo.userEmail, subscriptionsInfo.instancesObtained])

  useEffect(() => {
    if (!subscriptionsInfo.subscriptionsObtained){
      dispatch(getCustomerSubscriptions());
    }
  }, [subscriptionsInfo.subscriptionsObtained])

  useEffect(() => {
    if (subscriptionsInfo.subscriptionsObtained && subscriptionsInfo.subscriptions.length > 0) {
      let subscriptions = []
      subscriptionsInfo.subscriptions.map((subscription) => {
        if (subscription.status !== "cancelled") {
          let subscriptionCopy = {...subscription };
          subscriptionCopy.hasVirtualSpace = false;
          subscriptionCopy.url = "";
          subscriptionCopy.description = "";
          if (subscriptionsInfo.instancesObtained && subscriptionsInfo.virtualSpaces.length > 0){
            subscriptionsInfo.virtualSpaces.map((virtualSpace) => {
              if (subscriptionCopy.id === virtualSpace.chargebeePurchaseId) {
                subscriptionCopy.hasVirtualSpace = true;
                subscriptionCopy.url = virtualSpace.urls.admin;
                subscriptionCopy.description = virtualSpace.description
              }
            })
          }
          //console.log("...: ", subscriptionCopy)
          subscriptions.push(subscriptionCopy)
        }
      })
      setSubscriptions(subscriptions)
    }
  }, [subscriptionsInfo.subscriptions, subscriptionsInfo.virtualSpaces])

  function formatDate(timestamp) {
    const date = DateTime.fromSeconds(timestamp);
    const formattedDate = date.toFormat("MMMM dd, yyyy");
    return formattedDate;
  }

  function openSubscription(subscriptionId){
    navigate(`/mySubscription/${subscriptionId}`);
  }

  function goToCreate(subscriptionId){
    navigate(`/createVirtualSpace/${subscriptionId}`);
  }

  if (!subscriptionsInfo.loadedFirstTime) {
    return (
      <MySubscriptionsSkeleton />
    )
  }

  return (
    <>
      <div className="subscription--list">
        <div className="subscription--container">
          {subscriptions && subscriptions.length > 0?
            subscriptions.map((it, i) => (
            <div key={i} className="subscription--card">
              <div>
                <div className="subscription--number">
                  {i + 1}
                </div>
              </div>
              <div>
                <div className="subscription--header">
                  <div>
                    <p className="subscription--title">
                      {`${it.subscriptionItems[0].itemPriceId.split("-")[0]}`}
                        <span className="subscription--date">{` Created on: ${formatDate(it.createdAt)}`}</span>
                    </p>
                  </div>
                  <div className="edit--subscription">
                    <button className="custom--button" onClick={ev => openSubscription(it.id)}>Edit</button>
                  </div>
                </div>
                {it.hasVirtualSpace &&
                  <>
                    <div className="instace--url">{process.env.REACT_APP_URL_DOMAIN_NAME === `dev` ? `${it.url.replace("app", "dev")}` : `${it.url}`}</div>
                    <div className="subscription--description">{`${it.description}`}</div>
                  </>
                }
                {
                  !it.hasVirtualSpace &&
                  <div className="create--instance--container">
                      <button className="custom--button custom--button--marquet" onClick={ev => goToCreate(it.id)}>
                        Create Virtual Space
                      </button>
                  </div>
                }
              </div>
            </div>
              )):
            <Alert type={"info"}>
              <p>
                It looks like you don't have subscriptions. You can search our plans <a className="custom--links" href="https://www.marquet.cloud" target="_blank">here</a>
              </p>
            </Alert>
          }
        </div>
      </div>
    </>
  )
}

export default MySubscriptions;